import { Chip, Tooltip } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import React from 'react';
import { useTranslation } from 'react-i18next';

const AchReturnedChip = (props) => {
  const { t } = useTranslation();

  if (props.payment.transaction_status !== 'ACH-returned') {
    return null;
  }

  if (!props.payment?.source_ach_details?.return?.code) {
    return (
      <Chip
        size='small'
        variant='filled'
        color='error'
        label={t('payments.chipLabels.achReturned')}
      />
    );
  }

  return (
    <>
      <Tooltip
        placement='top'
        title={`${props.payment?.source_ach_details?.return?.code} - ${props.payment?.source_ach_details?.return?.reason}`}>
        <Chip
          size='small'
          variant='filled'
          color='error'
          label={t('payments.chipLabels.achReturned')}
          clickable
          onDelete={() => {}}
          deleteIcon={<HelpIcon />}
        />
      </Tooltip>
    </>
  );
};

export default AchReturnedChip;
